import * as React from 'react'
import { FC } from 'react'
import { Data, HoverSector } from './pie_chart'
import styles from './pie_chart.module.scss'

type Props = {
  center: number
  data: Data[]
  expandSize?: number
  startAngle?: number
  strokeColor?: string
  strokeWidth?: number
  onSectorHover?: HoverSector
}

const Sectors: FC<Props> = ({
  center,
  data,
  expandSize = 5,
  startAngle = 0,
  strokeColor = '#fff',
  strokeWidth = 1,
  onSectorHover
}) => {
  // sum each value of data to start from `0`
  const total = data.reduce((prevData, currentData) => prevData + currentData.value, 0)

  let angleStart = startAngle
  let angleEnd = startAngle

  return total > 0 ? (
    <g>
      {data.map((d, index) => {
        const isLarge = d.value / total > 0.5
        const angle = (360 * d.value) / total
        const radius = center + (d.expanded ? expandSize : 0) - strokeWidth / 2

        angleStart = angleEnd
        angleEnd = angleStart + angle

        const x1 = center + radius * Math.cos((Math.PI * angleStart) / 180)
        const y1 = center + radius * Math.sin((Math.PI * angleStart) / 180)
        const x2 = center + radius * Math.cos((Math.PI * angleEnd) / 180)
        const y2 = center + radius * Math.sin((Math.PI * angleEnd) / 180)

        const path = `
          M${center} ${center}
          L ${x1} ${y1}
          A ${radius} ${radius}, 0, ${isLarge ? 1 : 0}, 1, ${x2} ${y2}
          Z
        `

        return (
          <path
            key={`path${index}`}
            className={styles.path}
            d={path}
            fill={d.color}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
            onMouseEnter={e => onSectorHover(e, d, index)}
            onMouseLeave={e => onSectorHover(e, null, null)}
          >
            {d.title === null ? null : <title>{d.title}</title>}
          </path>
        )
      })}
    </g>
  ) : null
}

export default Sectors
